import { render } from "./ConfirmDiscardModal.vue?vue&type=template&id=4737d2ec"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"

import "./ConfirmDiscardModal.vue?vue&type=style&index=0&id=4737d2ec&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__